import toMap from '~/misc/toMap';

export default toMap([
  'INIT_RATE_CHECK',
  'REMOVE_RATE_CHECK',
  'GET_RATE_UPDATE_SWITCH',
  'SAVE_RATE_SWITCH',
]);



// WEBPACK FOOTER //
// ./src/modules/rate/types.js